export type UserAgent = 'desktop' | 'ios' | 'android';

function detectUserAgent(): UserAgent {
  if (typeof navigator === 'undefined') return 'desktop';

  const ua = navigator.userAgent;

  if (/Android/i.test(ua)) return 'android';

  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';

  // iPad with desktop-class browsing (reports as Mac but has touch)
  if (/Mac/.test(ua) && navigator.maxTouchPoints > 2) return 'ios';

  return 'desktop';
}

export function useUserAgent(): UserAgent {
  return detectUserAgent();
}

export function useIsMobile(): boolean {
  const ua = detectUserAgent();
  return ua === 'ios' || ua === 'android';
}
